export const filterMenuList = (dataRoute, apiRoute) => {
  return dataRoute
    .map((menuItem) =>
      filterMenu(
        menuItem,
        apiRoute.find((menuItemData) => menuItemData.code === menuItem.code)
      )
    )
    .filter((filteredMenuItem) => filteredMenuItem !== null);
};

function filterMenu(menuItem, correspondingMenuFromAPI) {
  if (
    !correspondingMenuFromAPI?.action_page?.find((e) => e.code === "Read")
      .is_active
  ) {
    return null;
  }

  const filteredSubMenu = menuItem.children
    ? menuItem.children
        .map((subItem) =>
          filterMenu(
            subItem,
            correspondingMenuFromAPI.sub.find(
              (subItemData) => subItemData.code === subItem.code
            )
          )
        )
        .filter((filteredSubItem) => filteredSubItem !== null)
    : null;

  return {
    ...menuItem,
    children: filteredSubMenu,
  };
}

// function getIsActive(menuData, actionPageCode) {
//   // for (const menuItem of menuData) {
//   for (const actionPage of menuData.action_page) {
//     if (actionPage.code === actionPageCode) {
//       return actionPage.is_active;
//     }
//   }
//   // }
//   // Return null if action page with the specified code is not found
//   return null;
// }

// getIsActive(correspondingMenuFromAPI, "Read");
